import React from 'react'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/config/store'
import Loading from 'core-system/Loading'
import StripeSyncStage from './StripeSyncStage'
import WorkforceSyncStage from './WorkforceSyncStage'
import { OnboardingStage } from '../onboardingSlice'

const GettingStartedView = React.memo(() => {
  const { profile, worksites } = useSelector(
    (state: AppState) => state.employer
  )
  const onboarding = useSelector((state: AppState) => state.onboarding)

  if (!worksites || !profile) {
    return <Loading fullPage withoutNav />
  }

  const getContent = (onboardingStage: OnboardingStage) => {
    switch (onboardingStage) {
      case 'WORKFORCE_SYNC':
        return <WorkforceSyncStage />
      case 'STRIPE_SYNC':
        return <StripeSyncStage />
      default:
        return <WorkforceSyncStage />
    }
  }

  return getContent(onboarding.stage)
})

// Helps to identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  GettingStartedView.displayName = 'GettingStartedView'
}

export default GettingStartedView
